export type ErrorCause = Error | string | null | undefined;

type ErrorWithCauseInstance = Error & {
	cause?: ErrorCause;
};

type ErrorConstructorWithCause = new (
	message?: string,
	options?: { cause?: ErrorCause },
) => ErrorWithCauseInstance;

const ErrorBase = Error as ErrorConstructorWithCause;

// A constructor value keeps `cause` typed without a `declare` class field or
// class/interface merge, both of which are rejected by this package's lint/build
// stack.
export const ErrorWithCause: ErrorConstructorWithCause = class ErrorWithCause extends ErrorBase {
	constructor(message?: string, options?: { cause?: ErrorCause }) {
		super(message, options);
		this.name = 'ErrorWithCause';

		const cause = options?.cause;
		if (cause !== undefined && !Object.prototype.hasOwnProperty.call(this, 'cause')) {
			Object.defineProperty(this, 'cause', {
				value: cause,
				configurable: true,
				writable: true,
			});
		}
	}
};

export const normalizeErrorCause = (cause: unknown): ErrorCause => {
	if (
		cause instanceof Error ||
		typeof cause === 'string' ||
		cause === null ||
		cause === undefined
	) {
		return cause;
	}

	try {
		return String(cause);
	} catch {
		return '[object Object]';
	}
};
